export const environment = {
  production: false,
  apiProjectUrl: "https://a314-projects-dev.tc.avwaveinteractive.com/projects",
  apiUrlAdmin:
    "https://a314-admin-users-dev.tc.avwaveinteractive.com/admin-users",
  apiGoogleStorage:
    "https://a314-google-storage-dev.tc.avwaveinteractive.com/storage",
  urlStorage: "https://storage.googleapis.com/tc-avwave-dev/",
  testUser: {
    // tslint:disable-line
    token: "cualquiercosa",
    email: "user@user.user",
  },
};